<template>
  <div class="RwvVariantSelection">
    <b-form-group
      :id="'input-group-manufacturer-' + index"
      :label-for="'input-manufacturer-' + index"
      v-b-tooltip.hover
      title="Hersteller">

      <b-form-select
        :id="'input-manufacturer-' + index"
        v-model="manufacturer"
        :value="manufacturer"
        v-on:change="changedManufacturer"
        required>

        <option slot="first" :value="this.emptyManufacturer">
          Hersteller wählen...
        </option>

        <option
          v-for="manufacturer in manufacturers"
          :key="manufacturer.slug"
          :value="manufacturer">

            {{manufacturer.name}}
          </option>
        </b-form-select>
    </b-form-group>
    <b-form-group
      :id="'input-group-model-' + index"
      :label-for="'input-model-' + index"
      v-b-tooltip.hover
      title="Modell">

      <b-form-select
        :disabled="manufacturer.slug == ''"
        id="input-model"
        v-model="model"
        :value="model"
        v-on:change="changedModel"
        required>

        <option slot="first" :value="this.emptyModel">
          Modell wählen...
        </option>

        <option
          v-for="model in filteredModels(manufacturer.slug)"
          :key="model.slug"
          :value="model">

            {{model.name}}
        </option>
      </b-form-select>
    </b-form-group>
    <b-form-group
      :id="'input-group-variant-' + index"
      :label-for="'input-variant-' + index"
      v-b-tooltip.hover
      title="Baujahr">

      <b-form-select
        :id="'input-variant-' + index"
        :disabled="model.slug == ''"
        v-model="variant"
        v-on:change="changedVariant"
        :value="variant"
        required>

        <option slot="first" :value="this.emptyVariant">
          Baujahr wählen...
        </option>


        <option
          v-for="variant in filteredVariants(model.slug)"
          :key="variant.slug"
          :value="variant">

          {{variant.year + variant.variant}}
        </option>
      </b-form-select>
    </b-form-group>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import store from "@/store";
import {
  FETCH_MANUFACTURERS,
  FETCH_MODELS,
  FETCH_VARIANTS
} from "@/store/actions.type";

export default {
  name: "RwvVariantSelection",
  data() {
    return {
      variant: {},
      manufacturer: {},
      model: {},
      emptyVariant: {},
      emptyModel: {},
      emptyManufacturer: {},
      index: 99
    }
  },
  created() {
    this.emptyManufacturer = {
        slug: "",
        name: ""
      }
    this.emptyModel = {
        slug: "",
        name: ""
      }
    this.emptyVariant = {
        variant: "",
        year: "",
        slug: ""
      }
    this.manufacturer = JSON.parse(JSON.stringify(this.emptyManufacturer));
    this.model = JSON.parse(JSON.stringify(this.emptyModel));
    this.variant = JSON.parse(JSON.stringify(this.emptyVariant));
  },
  computed: {
    ...mapGetters(["manufacturers", "variants", "models"])
  },
  mounted() {
    this.fetchManufacturers()
    this.fetchModels()
    this.fetchVariants()
  },
  methods: {
    fetchManufacturers() {
      this.$store.dispatch(FETCH_MANUFACTURERS,
      {
        order: 'name',
      });
    },
    fetchModels(slug) {
      this.$store.dispatch(FETCH_MODELS,
        {
          order: 'name',
          include: "manufacturer"
        });
    },
    fetchVariants(slug) {
      // if (slug) {
      //   this.$store.dispatch(FETCH_VARIANTS, {"where":{"variantSlug":{"like":slug}}});
      // } else {
        this.$store.dispatch(FETCH_VARIANTS,
          {
            order: 'variant',
            include: {
              relation: "model",
              scope: {
                include: "manufacturer"
              }
            }
          });
      // }
    },
    changedManufacturer() {
      this.model = JSON.parse(JSON.stringify(this.emptyModel));
      this.changedModel()
    },
    changedModel() {
      this.variant = JSON.parse(JSON.stringify(this.emptyVariant));
      this.changedVariant()
    },
    changedVariant() {
      this.$emit("changedVariant", this.manufacturer.slug, this.model.slug, this.variant.slug, this.index)
    },
    filteredModels(slug) {
      return this.models.filter(function (el) {
        return el.manufacturerSlug == slug
      });
    },
    filteredVariants(slug) {
      return this.variants.filter(function (el) {
        return el.modelSlug == slug
      });
    },
  }
};
</script>

<style lang="scss">
.RwvVariantSelection {
  margin-bottom: 1rem;
  #input-group-variant {
    margin-bottom: 0;
  }
}
</style>
